<template>
  <div>
    <navigation-layout>
      <router-view></router-view>
    </navigation-layout>
  </div>
</template>

<script>
import NavigationLayout from '@/atom/layout/NavigationLayout';

export default {
  name: 'App',
  components: {
    NavigationLayout
  },
  data () {
    return {
      //
    }
  }
}
</script>
